import { FC, useState } from 'react';
import { MainStreamDataStep } from '@/components/streams/stream-form/regular-stream-form/main-stream-data-step.tsx';
import { PaidStreamDataStep } from '@/components/streams/stream-form/regular-stream-form/paid-stream-data-step/paid-stream-data-step.tsx';
import { StreamTypeStep } from '@/components/streams/stream-form/regular-stream-form/stream-type-step.tsx';
import { StreamFormInputs } from '@/components/streams/stream-form/stream-form.tsx';
import { StreamPricingType } from '@/components/streams/stream-pricing-type.tsx';

interface RegularStreamFormProps {
  step: number;
  setStep: (step: number) => void;
  onClose: () => void;
  streamPricingType?: StreamPricingType;
  setStreamPricingType?: (value: StreamPricingType) => void;
  initialValues?: StreamFormInputs;
}

export const RegularStreamForm: FC<RegularStreamFormProps> = ({
  step,
  setStep,
  onClose,
  streamPricingType,
  setStreamPricingType,
  initialValues,
}) => {
  const [hasAcceptedPolicy, setHasAcceptedPolicy] = useState(false);

  const hasInitialValues = !!initialValues;
  const isPaid =
    streamPricingType === StreamPricingType.Paid || !!initialValues?.paidData;

  const mainFormInfoTitle = isPaid
    ? 'You have connected and verified your Stripe account!'
    : 'Your content will be accessible to all users without charge.';
  const mainFormInfoDescription = 'Fill in the following fields to proceed.';

  return step === 1 && streamPricingType && setStreamPricingType ? (
    <StreamTypeStep
      setStreamPricingType={setStreamPricingType}
      streamPricingType={streamPricingType}
      onClose={onClose}
      onNext={() => setStep(2)}
    />
  ) : step === 2 ? (
    <MainStreamDataStep
      hasInitialValues={hasInitialValues}
      setNextStep={isPaid ? () => setStep(3) : undefined}
      setPrevStep={!hasInitialValues ? () => setStep(1) : undefined}
      infoTitle={!hasInitialValues ? mainFormInfoTitle : undefined}
      infoDescription={!hasInitialValues ? mainFormInfoDescription : undefined}
    />
  ) : step === 3 ? (
    <PaidStreamDataStep
      onBack={() => setStep(2)}
      hasAcceptedPolicy={hasAcceptedPolicy}
      onAcceptPolicy={setHasAcceptedPolicy}
      hasInitialValues={hasInitialValues}
    />
  ) : null;
};
